<template>
  <div class="ub-box ub-ver-v">
    <input @change="checkService($event)" class="z-check" type="checkbox" :checked="check" :name="name" :value="label"/>
    <label v-if="label" class="z-select-none z-margin-left-8-precent z-color-666 z-font-size-15">{{label}}</label>
  </div>
</template>
<script>
  export default {
    props:['check','name','label','index'],
    methods:{
      checkService(evt){ this.$emit('checkService',evt.target.checked, this.label, this.name, this.index) }
    }
  }
</script>
<style scoped="scoped">
  .z-check{
    cursor:pointer;
    width:17px;
    height:17px;
    text-align:center;
    line-height: 17px;
    border:1px solid #2ebace;
    border-radius:3px;
    background-clip: content-box;
    -webkit-appearance:none;
    -webkit-user-select:none;
    outline: none;
    background:transparent;
    position: relative;
    transition: all .45s cubic-bezier(.23,1,.32,1);
  }
  .z-check:before{content:'\2713';position:absolute;top:0;left:0;right:0;bottom:0;color:#fff;font-size:1.2rem;line-height:1.2rem;font-weight:800;transform: scale(0);transition: transform .3s cubic-bezier(.29,.36,1,1.61);}
  .z-check:checked{background:#2ebace;border:1px solid #2ebace;}
  .z-check:checked:before{transform: scale(1);}
</style>



// WEBPACK FOOTER //
// src/components/commons/XcheckBox.vue